var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "pbc" },
    [
      _c(
        "el-radio-group",
        {
          staticClass: "switch",
          on: { change: _vm.handleClick },
          model: {
            value: _vm.active,
            callback: function ($$v) {
              _vm.active = $$v
            },
            expression: "active",
          },
        },
        [
          _vm.getSite.hasInterim
            ? _c("el-radio-button", { attrs: { label: "1" } }, [
                _vm._v(_vm._s(_vm.$t("COMMON_INTERIM"))),
              ])
            : _vm._e(),
          _c("el-radio-button", { attrs: { label: "2" } }, [
            _vm._v(_vm._s(_vm.$t("COMMON_FINAL"))),
          ]),
        ],
        1
      ),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.active == "1",
              expression: "active=='1'",
            },
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticClass: "wl-table interimTable",
          attrs: {
            data: _vm.initData.interimPbcList,
            height: "300",
            border: "",
            stripe: "",
          },
          on: { "selection-change": _vm.handleSelectionChangeInterim },
        },
        [
          _c("el-table-column", { attrs: { type: "selection", width: "40" } }),
          _c("el-table-column", {
            attrs: {
              prop: "groupName",
              width: "180",
              "show-overflow-tooltip": "",
              label: _vm.$t("PAGE_PBCLIST_NAME"),
            },
          }),
          _c("el-table-column", {
            attrs: {
              width: "160",
              label: _vm.$t("TABLE_HEADER_periodEndDate"),
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.formatDate(scope.row.periodEndDate)) +
                        "\n      "
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              prop: "detailedInfoReq",
              label: _vm.$t("TABLE_HEADER_detailedInfoReq"),
            },
          }),
          _c("el-table-column", {
            attrs: { width: "140", label: _vm.$t("TABLE_HEADER_DETAILS") },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "text" },
                        on: {
                          click: function ($event) {
                            return _vm.details(scope.row)
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("COMMON_VIEW")))]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.active == "2",
              expression: "active=='2'",
            },
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticClass: "wl-table finalTable",
          attrs: {
            data: _vm.initData.finalPbcList,
            height: "300",
            border: "",
            stripe: "",
          },
          on: { "selection-change": _vm.handleSelectionChangeFinal },
        },
        [
          _c("el-table-column", { attrs: { type: "selection", width: "40" } }),
          _c("el-table-column", {
            attrs: {
              prop: "groupName",
              width: "180",
              label: _vm.$t("PAGE_PBCLIST_NAME"),
            },
          }),
          _c("el-table-column", {
            attrs: {
              width: "160",
              label: _vm.$t("TABLE_HEADER_periodEndDate"),
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.formatDate(scope.row.periodEndDate)) +
                        "\n      "
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              prop: "detailedInfoReq",
              label: _vm.$t("TABLE_HEADER_detailedInfoReq"),
            },
          }),
          _c("el-table-column", {
            attrs: { width: "140", label: _vm.$t("TABLE_HEADER_DETAILS") },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "text" },
                        on: {
                          click: function ($event) {
                            return _vm.details(scope.row)
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("COMMON_VIEW")))]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }